import React, { useState, useEffect } from "react";
import { DataForm, LoaderInfo } from "../../../../../libs/react-mpk/components";
import { number, utils } from "../../../../../libs/react-mpk/services";
import { storage } from "../../../../../services";
import t from "counterpart";
import { inject, observer } from "mobx-react";
import moment from "moment";

const generate = () => {
  let data = storage.generate(storage.keys.SPT_1770S_DETAIL_LAMP_IC, {
    daftarBuktiPotong: [],
  });

  return data;
};

const { inputTypes } = DataForm;
const DetailLampIC = (props) => {
  const [ready, setReady] = useState(false);
  const [defaultData, setDefaultData] = useState({});
  useEffect(() => {
    let defData = storage.get(storage.keys.SPT_1770S_DETAIL_LAMP_IC);
    setDefaultData(defData);
    setReady(true);
  }, []);

  return ready ? (
    <DataForm
      baseId="spt-1770S-header-lamp-IC"
      className="mpk-padding-NONE padding-all"
      style={{
        width: "100%",
        maxWidth: 800,
      }}
      asDialog={false}
      editable={props.isEditable}
      defaultData={defaultData}
      definitions={[
        {
          inputType: inputTypes.LIST,
          label: t.translate("column.daftarBuktiPotong"),
          key: "daftarBuktiPotong",
          defaultData: {
            npwpPemotong: "",
            namaWPPemotong: "",
            noBukti: "",
            tanggalBukti: "",
            kodePasal: props.envStore.env.spt.KD_PASAL[0].value,
            jumlahPPH: "0",
          },
          definitions: [
            {
              inputType: inputTypes.INPUT,
              label: t.translate(
                "modules.submission.sptForm.1770S.DetailLampIC.NPWP_PEMOTONG"
              ),
              key: "npwpPemotong",
              validation: "digits:15",
              required: (item, index_list) => {
                return item.daftarBuktiPotong[index_list] &&
                  item.daftarBuktiPotong[index_list].kodePasal === "SKPPKP"
                  ? false
                  : true;
              },
              disabled: (item, index_list) => {
                return item.daftarBuktiPotong[index_list] &&
                  item.daftarBuktiPotong[index_list].kodePasal === "SKPPKP"
                  ? true
                  : false;
              },
            },
            {
              inputType: inputTypes.INPUT,
              label: t.translate(
                "modules.submission.sptForm.1770S.DetailLampIC.NAMA_WP_PEMOTONG"
              ),
              key: "namaWPPemotong",
              required: true,
              validation: "min:4",
              helpText: t.translate("sentence.minimumName"),
              disabled: (item, index_list) => {
                return item.daftarBuktiPotong[index_list] &&
                  item.daftarBuktiPotong[index_list].kodePasal === "SKPPKP"
                  ? true
                  : false;
              },
            },
            {
              inputType: inputTypes.INPUT,
              label: t.translate(
                "modules.submission.sptForm.1770S.DetailLampIC.NO_BUKTI"
              ),
              key: "noBukti",
              required: true,
            },
            {
              inputType: inputTypes.SELECT,
              label: t.translate(
                "modules.submission.sptForm.1770S.DetailLampIC.KD_PASAL"
              ),
              key: "kodePasal",
              options: props.envStore.env.spt.KD_PASAL,
              required: true,
            },
            {
              inputType: inputTypes.INPUT,
              label: t.translate(
                "modules.submission.sptForm.1770S.DetailLampIC.TGL_BUKTI"
              ),
              key: "tanggalBukti",
              type: "date",
              required: true,
              max: moment(props.envStore.env.timeStamp).format("YYYY-MM-DD"),
            },
            {
              inputType: inputTypes.INPUT_MASK_NUMBER,
              label: t.translate(
                "modules.submission.sptForm.1770S.DetailLampIC.JML_PPH"
              ),
              thousandSeparator: ".",
              decimalSeparator: ",",
              isNumericString: true,
              allowNegative: true,
              key: "jumlahPPH",
              required: true,
            },
          ],
        },
      ]}
      onChange={(data, key, value, parentKey, index_list) => {
        if (key === "kodePasal") {
          if (value === "SKPPKP") {
            data[parentKey][index_list].npwpPemotong = "";
            data[parentKey][index_list].namaWPPemotong = "SKPPKP";
          } else {
            data[parentKey][index_list].npwpPemotong = "";
            data[parentKey][index_list].namaWPPemotong = "";
          }
        }
        return data;
      }}
      onBeforeChange={(key, value) => {
        // value =
        //   ["jumlahPPH"].indexOf(key) >= 0
        //     ? number.format(number.clearFormat(value.replace(/\D/g, "")))
        //     : ["npwpPemotong"].indexOf(key) >= 0
        //     ? value.replace(/\D/g, "")
        //     : value;
        return value;
      }}
      onSubmit={(data, callback) => {
        let isDuplicate = utils.isDuplicateObjectInArray(
          data.daftarBuktiPotong,
          ["noBukti", "npwpPemotong"]
        );

        if (isDuplicate) {
          callback(new Error(t.translate("sentence.duplicateBuktiPotong")));
        } else {
          props.onSave(storage.keys.SPT_1770S_DETAIL_LAMP_IC, data);
          callback(t.translate("sentence.savedItem"), false);
        }
      }}
      submitLabel={t.translate("column.save")}
    />
  ) : (
    <LoaderInfo />
  );
};

DetailLampIC.generate = generate;

export default inject("envStore")(observer(DetailLampIC));
